define((require) => {
    "use strict";

    var Backbone         = require("backbone"),
        EmailUtil        = require("util/EmailUtil"),
        IdValidator      = require("util/IdValidator"),
        ImprovedView     = require("editor/zbone/ImprovedView"),
        Login            = require("security/Login"),
        SequentialButton = require("util/SequentialButton"),
        {isBlank}        = require("shared/util/StringUtils"),
        ValidateBehavior = require("ui/behaviors/ValidateBehavior"),
        template         = require("ui/user/ADSignInView.tpl");

    var SHAKE_EFFECT_CLASS_NAME = "shake";

    /**
     * Form for logging into accounts using Zmags Active Directory credentials.
     *
     * @author Bo Gotthardt
     * @class ADSignInView
     *
     * @cfg {String} [username] Default value for the username field.
     */
    return ImprovedView.extend({

        _action: null,

        template: template,

        model: new Backbone.Model(),

        ui: {
            form:         "#ad-form",
            signInButton: "#ad-sign-in-button",
            publicatorId: "#ad-publicator-id", // to test if both email, pub id, and exp id are all empty...
            experienceId: "#ad-exp-id"
        },

        events: {
            "submit #ad-form": function(event) {
                event.preventDefault();
                this._action();
                return false;
            }
        },

        bindings: {
            "#ad-email":         "username",
            "#ad-publicator-id": "publicatorUserId",
            "#ad-exp-id":        "experienceId",
            "#ad-username":      "ldapUsername",
            "#ad-password":      "ldapPassword"
        },
        behaviors: {
            validateBehavior: {
                behaviorClass: ValidateBehavior,
                inputValidation: {
                    "#ad-email": {
                        validator: function(email, type) {
                            // On submit, we must have at least one identifier for the user to log in as...
                            var blank = isBlank(email);

                            if (type === "submit") {
                                if (blank && isBlank(this.ui.publicatorId.val()) && isBlank(this.ui.experienceId.val())) {
                                    return false;
                                }
                            }
                            return blank || EmailUtil.validateEmail(email);
                        },
                        errorText: function(email, type) {
                            if (type === "submit" && isBlank(email)) {
                                return "Creator username, Publicator id, or Experience id required";
                            }
                            return "Not a valid email";
                        }
                    },
                    "#ad-exp-id": {
                        validator: function(id) {
                            return IdValidator.isValid(id);
                        },
                        errorText: "Not a valid experience id"
                    },
                    "#ad-username": {
                        validator: function(username) {
                            return !isBlank(username);
                        },
                        errorText: "AD username required"
                    },
                    "#ad-password": {
                        validator: function(password) {
                            return !isBlank(password);
                        },
                        errorText: "AD password required"
                    }
                }
            }
        },

        /**
         * Applies the "shake" effect to this view.
         *
         * @param {Boolean} [enable] Optional boolean value, if <tt>false</tt> the effect will be removed.
         */
        shake: function(enable) {
            if (typeof enable === "undefined" || enable === true) {
                this.$el.addClass(SHAKE_EFFECT_CLASS_NAME);
            } else {
                this.$el.removeClass(SHAKE_EFFECT_CLASS_NAME);
            }
        },

        /**
         * @private
         * Tries to perform an ad login. <p>
         *
         * Note: the ad login is actually throttled on the backend on the ad username, but that is deemed such a
         * special case we do not want to add logic for it here in the frontend.
         */
        _login: function() {
            if (!this.inputValidation()) {
                return false;
            }

            this.shake(false);

            return Login.loginActiveDirectory(this.model)
                .done((principal) => {
                    return this.options.loginDeferred.resolve(principal, this.model);
                })

                .fail(() => {
                    this.shake(true);
                });
        },

        onRender: function() {
            var currentFragment = Backbone.history.fragment;
            // Add default values to fields where applicable...
            var index = currentFragment.indexOf("experience/");
            if (index !== -1) {
                this.model.set("experienceId", currentFragment.substring(index + 11, index + 35));
            }

            index = currentFragment.indexOf("publicatorUser/");
            if (index !== -1) {
                this.model.set("publicatorUserId", currentFragment.substring(index + 15, index + 23));
            }

            if (this.options.username) {
                this.model.set("username", this.options.username);
            } else {
                index = currentFragment.indexOf("username/");
                if (index !== -1) {
                    this.model.set("username", currentFragment.substring(index + 9));
                }
            }

            this._action = SequentialButton.add(this.ui.signInButton, this._login.bind(this));
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/user/ADSignInView.js